module.exports = __webpack_public_path__ + "img/ipass.f241b1ce.svg";